import { SectionTitleProps } from '../Cockpit.types'

type GetSectionsTitlesProps = {
  sectionUuid: string
  titles?: SectionTitleProps[]
}

function getSectionTitle({ sectionUuid, titles }: GetSectionsTitlesProps) {
  if (!titles || titles?.length === 0 || !sectionUuid) {
    return ''
  }

  return (
    titles.find((titleObject) => titleObject?.complement === sectionUuid)
      ?.des || ''
  )
}

export default getSectionTitle
